import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from "react"
import { Image } from '@sitecore-jss/sitecore-jss-react';  

import { urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import { isMobile, equalHeight } from '../../utilities/FrontFunctions/AoxGlobalFrontFunctions'
import '../../assets/css/0020_objects/0640_obj_push_card_thematique.css'

class ObjPushThematiqueFormation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: isMobile(),
		};
	}

	componentDidMount() {
		window.addEventListener('resize', this.throttleWindowResizeCustomSelect);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeCustomSelect);
	}

	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_push_card-thematique .ctn_text_card");
		});
	}

	render() {
        const { datasTheme } = this.props;

		return (<>{datasTheme && <>
			<div className="obj_push_card-thematique">
                <a href={urlToHost(datasTheme.url)}>
					<div className="ctn_media_card">
						<div className="obj_image">
							<picture className="ctn_image fade-in">
                                <Image field={datasTheme.pageImage.jss}></Image>
							</picture>
						</div>
					</div>

					<div className="ctn_content_card">
						<div className="ctn_text_card">
							<h3 className="t_title">
								<strong>{datasTheme.pageTitle.value}</strong>
							</h3>
							{datasTheme.pageSubTitle.value !== ""
                                ? <p className="t_desc">{datasTheme.pageSubTitle.value}</p>
                                : <p className="t_desc">{datasTheme.formationsTheme.targetItems.length} {datasTheme.formationsTheme.targetItems.length > 1 ? "formations" : "formation"}</p>
                            }
						</div>
					</div>
				</a>
			</div>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(ObjPushThematiqueFormation));